import { useCallback, useEffect, useState, Dispatch, SetStateAction } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ethers } from 'ethers'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { Col, DatePicker, InputNumber, Modal, Row, Select, Dropdown, Empty, Menu } from 'antd'
import { setGetProfileUserAddress } from 'hooks/setGetProfileUser'
import { compactAddress, formatCode } from 'helpers'
import { CloseIcon, Link, SpotIcon, Box } from 'widgets'
import { CHAIN_ID_MAPPING, CONTRACT_AUCTION, CONTRACT_MARKET, CONTRACT_TOKEN_ASDIT } from 'config/constants'
import Aution from 'widgets/Svg/Icons/Aution'
import { RangePickerProps } from 'antd/lib/date-picker'
import moment from 'moment'
import useToast from 'hooks/useToast'
import { formatBigNumber, formatNumberToMillions, getBigNumberString } from 'utils/formatBalance'
import BaseButton from 'widgets/BaseButton'
import { useRouter } from 'next/router'
import { useWeb3React } from '@web3-react/core'
import useGetFeeBid from 'hooks/useGetFeeBid'
import { setAddToCart } from 'state/cart/actions'
import { useCallWithGasPrice } from 'hooks/useCallWithGasPrice'
import { useAuctionContract, useCreateTokenContract, useMarketContract, useNFTBaseContract } from 'hooks/useContract'
import useGetAuction from 'hooks/useGetAuction'
import useCatchTxError from 'hooks/useCatchTxError'
import useApproveToken from 'hooks/useApproveToken'
import useGetSpot from 'hooks/useGetSpot'
import Filter from 'widgets/Svg/Icons/Filter'
import { setFilterBlur, setIsModalOpenModalConfirm } from 'state/global/actions'
import { useRemoveAddToCart } from 'hooks/useCart'
import { useGetAmountNft } from 'hooks/useGetAmountNft'
import { useGetListActivivy } from 'hooks/useGetDataFromGraph'
import { useFormatCurrency } from 'hooks/useFormatCurrency'
import DatePickerNow from './DatePickerNow'

const WrapperContent = styled.div`
  background: #fff;
  border-radius: 30px 30px;
  margin: 0 -24px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

  button {
    cursor: pointer;
  }

  img {
    max-width: 100%;
  }

  .modal-title {
    border-radius: 30px 30px 0px 0px;
    background: var(--blue, #006dfe);
    padding: 6px 15px;

    p {
      font-weight: 700;
      color: #fff;
      text-align: center;
      font-size: 20px;
    }
  }

  .modal-body {
    padding: 20px;

    ${({ theme }) => theme.mediaQueries.md} {
      padding: 40px 32px;
    }

    .item-info-name {
      font-weight: 700;
      color: #000;
      font-size: 24px;
      line-height: 14px;
      margin-bottom: 20px;
    }

    .wrap-nft {
      .wrap-avatar {
        position: relative;
        width: 100%;
        padding-top: 100%;
        overflow: hidden;
        border-radius: 30px;
        margin-top: 12px;

        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        video {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }

      .wrap-info {
        .item-info {
          display: flex;
          align-items: center;
          justify-content: space-between;

          &:not(:last-child) {
            margin-bottom: 12px;
          }

          p {
            font-family: Inter;
            line-height: 16px;
            font-size: 14px;
            color: #000;

            &:first-child {
              margin-right: 10px;
            }

            &:last-child {
              text-align: right;
            }
          }

          a {
            p {
              color: #006def;
            }
          }
        }
      }
    }

    .wrap-listing-method {
      .item-listing-method-title {
        color: #000;
        font-size: 16px;
        font-weight: 700;

        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }

      .wrap-item-listing-method {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        row-gap: 15px;

        ${({ theme }) => theme.mediaQueries.md} {
          flex-direction: row;
        }

        &:not(:last-child) {
          margin-bottom: 15px;
        }

        button {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 20px;
          text-align: center;
          font-weight: 700;
          text-transform: capitalize;
          font-size: 16px;
          width: 100%;
          color: #6d6d6d;
          border: none;
          background: #fff;
          border: 1px solid #bbb;
          height: 40px;
          padding: 5px 15px;

          svg {
            width: 15px;
            margin-right: 6px;

            path,
            rect {
              fill: #6d6d6d;
            }
          }

          &.active {
            color: #fff;
            background: #006dfe;
            border: 1px solid #006dfe;

            svg {
              path,
              rect {
                fill: #fff;
              }
            }
          }
        }

        .item-listing-method {
          width: 100%;

          ${({ theme }) => theme.mediaQueries.md} {
            &:not(:last-child) {
              margin-right: 15px;
            }
          }
        }
      }
    }

    .button-confirm {
      margin-top: 48px;

      button {
        font-weight: 700;
        text-transform: capitalize;
        text-align: center;
        font-size: 16px;
        color: #bbb;
        height: 40px;
        width: 100%;
        border-radius: 10px;
        background: #efefef;
        border: none;

        &.active {
          color: #fff;
          background: #006dfe;
        }
      }

      [type='button'] {
        font-weight: 700;
        text-transform: capitalize;
        text-align: center;
        font-size: 16px;
        color: #bbb;
        width: 100%;
        border-radius: 10px;
        background: #efefef;
        border: none;

        &.active {
          color: #fff;
          background: #006dfe;
        }
      }
    }
  }

  .ant-input-number {
    display: flex;
    align-items: center;
    height: 40px;
    border-radius: 20px;
    border: 1px solid #6d6d6d;
    background: #fff !important;
    overflow: hidden;
    outline: none;
    width: 100%;
  }

  .ant-input-number-group-wrapper {
    width: 100%;

    .ant-input-number-group {
      border-radius: 20px;
      border: 1px solid #6d6d6d;
      background: #fff !important;
      overflow: hidden;

      .ant-input-number-group-addon {
        background-color: transparent;
        border: none;
      }

      .ant-input-number {
        border: none;
        background: #fff !important;
      }

      .ant-select-selector {
        position: relative;
        width: max-content;

        &:before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          height: 20px;
          width: 1px;
          background: #6d6d6d;
        }

        .ant-select-selection-item {
          display: flex;
          align-items: center;

          img {
            margin-right: 3px;
          }
        }
      }
    }

    input {
      font-size: 12px;
      width: 100%;
      height: 40px;
      color: #000 !important;
    }

    .ant-input-number-handler-wrap {
      display: none;
    }
  }

  .ant-picker {
    height: 40px;
    width: 100%;
    border-radius: 20px;
    border: 1px solid #6d6d6d;
    background: #fff;

    input {
      font-size: 12px;
      width: 100%;
      height: 40px;
      color: #000 !important;
    }
  }
  .box-info {
    margin-top: 12px;
    .ant-dropdown-trigger {
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 15px;
      height: max-content;
      width: 90px;
      min-height: 30px;
      color: #000000;
      background: #efefef;
      border-radius: 5px;
      padding-left: 10px;
      cursor: pointer;
      transition: 0.2s;

      svg {
        font-size: 17px;
        transform: rotate(-90deg);
        margin-left: 7px;
        transition: 0.2s;
      }

      &:hover,
      &.ant-dropdown-open {
        background: #006dfe;
        color: #ffffff;

        svg {
          transform: unset;
        }
      }
    }

    button {
      &.ant-dropdown-trigger {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        background: #d9d9d9;
        border: none;
        border-radius: 50%;
        padding: 5px 4px;
        cursor: pointer;

        svg {
          transform: unset;
          margin-left: unset;
          fonst-size: 16px;
        }

        &:hover,
        &.ant-dropdown-open {
          background: #006dfe;

          svg {
            font-size: 18px;

            path {
              fill: #ffffff;
            }
          }
        }
      }
    }

    p {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
      color: #000000;
    }

    a {
      p {
        color: #006dfe;
      }
    }

    .box-info-content {
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      max-height: 200px;
      overflow: auto;
      padding-right: 8px;

      .info-content-social {
        padding-top: 15px;
        flex-wrap: wrap;
        margin: 0 -2px;

        a {
          display: block;
          padding: 4px;

          img {
            width: 36px;
          }
        }
      }

      &.box-info-chart {
        padding: 14px 20px 10px 20px;
        border: 0.5px solid #000000;
        border-radius: 15px;
        max-height: unset;
      }
    }

    .box-info-table {
      height: 200px;
      overflow-y: scroll;
      transform: translateX(0);
      padding: 12px 6px;
      background-color: #f5f5f5;
      border-radius: 12px;
      &::-webkit-scrollbar {
        width: 6px;
      }
    }

    table {
      width: 100%;
      min-width: max-content;

      thead {
        position: sticky;
        top: 0;
        z-index: 1;
      }

      th {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 15px;
        text-align: left;
        padding: 0 15px 13px 15px;
      }

      tr {
        p {
          font-family: 'Inter';
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          line-height: 15px;
        }

        a {
          p {
            color: #006dfe;
          }
        }

        td {
          padding: 6px 15px 12px;
          position: relative;

          &.price {
            p {
              &:nth-child(1) {
                font-weight: 700;
                color: #000000;
              }

              &:nth-child(2) {
                font-size: 9px;
                line-height: 11px;
                color: #6d6d6d;

                position: absolute;
                bottom: 0px;
              }
            }
          }
        }
      }
    }
  }
`

const WrapperIcon = styled.div`
  transform: translate(-29px, 27px);

  svg {
    rect {
      fill: #fff;
    }
  }
`

const ModalLoading = styled.div`
  background-color: #fff;
  margin: -24px;
  border-radius: 15px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
  padding: 60px 36px;

  .title-modal {
    text-align: center;
    margin-bottom: 20px;

    video {
      width: 70px;
    }
  }

  .body-modal {
    text-align: center;

    p {
      color: #000;
      text-align: center;
      font-size: 14px;
      font-family: Inter;
      font-style: normal;
      font-weight: 400;
      line-height: 19px;
      margin-bottom: 25px;

      &.body-modal-title {
        color: #000;
        text-align: center;
        font-size: 24px;
        font-family: 'Familjen-Grotesk';
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-bottom: 10px;
      }

      a {
        display: contents;
        color: #006dfe;
        font-weight: 700;
      }
    }

    .action-modal {
      display: flex;
      justify-content: center;
      width: 100%;

      button {
        width: 100%;
        max-width: 149px;
        min-height: 37px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 19px;
        text-align: center;
        color: #ffffff;
        border-radius: 5px;
        background: #006dfe;
        border: none;
        cursor: pointer;

        &:hover {
          background: linear-gradient(143.11deg, #006dfe 21.44%, #43e8e1 126.28%);
        }

        &:not(:last-child) {
          margin-right: 10px;
          transition: 0.1s;

          &:hover {
            background: #006dfe;
            color: #ffffff;
          }
        }
      }

      .btn-cancel {
        background: transparent;
        border: 1px solid #c7c7c7;
        color: #000000;
      }
    }
  }
`
const CustomeMenu = styled.div`
  .ant-dropdown-menu {
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 1px 0px 2px rgba(0, 0, 0, 0.79);
    backdrop-filter: blur(5px);
    border-radius: 10px;
    border: none;
    min-width: 112px;
    padding: 0;
    overflow: hidden;

    .ant-dropdown-menu-title-content {
      display: flex;
      align-items: center;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 700;
      color: #000000;

      img {
        margin-right: 6px;
        width: 15px;
      }
    }
  }

  .ant-switch {
    background-color: #1890ff;
    margin-left: 21px;
  }

  .ant-dropdown-menu-item:hover,
  .ant-dropdown-menu-submenu-title:hover,
  .ant-dropdown-menu-item.ant-dropdown-menu-item-active,
  .ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-active,
  .ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-active,
  .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-active {
    background: #ffffff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
  }

  .ant-dropdown-menu-item.active,
  .ant-dropdown-menu-item.active:hover {
    background: rgba(0, 109, 254, 0.2);
    box-shadow: none;
    position: relative;

    .ant-dropdown-menu-title-content {
      color: #006dfe;
    }
  }

  .ant-dropdown-menu-item.active::after {
    content: '';
    position: absolute;
    right: 12px;
    width: 4px;
    height: 4px;
    background-color: #006dfe;
    border-radius: 50%;
  }
`
const dataFilter = ['Sale', 'Listing', 'Transfer', 'All']

const { Option } = Select

const disabledDate: RangePickerProps['disabledDate'] = (current) => {
  return (current && current < moment().endOf('day')) || current > moment().add(7, 'days')
}

const selectAfterPrice = (
  <Select defaultValue="USDT">
    <Option value="USDT">
      <img width={15} src="/images/coins/usdt.svg" alt="" /> USDT
    </Option>
  </Select>
)

const ActivityItem = ({ data, detail }) => {
  const [fromUserProfile, setFromUserProfile] = useState<any>(null)
  const [toUserProfile, setToUserProfile] = useState<any>(null)
  const [getFormatCurrency] = useFormatCurrency()

  useEffect(() => {
    setGetProfileUserAddress(data?.from, (res) => setFromUserProfile(res))
    setGetProfileUserAddress(data?.to, (res) => setToUserProfile(res))
  }, [data])

  return (
    <tr>
      <td className="from">
        <Link
          href={
            data?.from?.toLowerCase() === '0x0000000000000000000000000000000000000000'.toLowerCase() ||
            data?.from?.toLowerCase() === CONTRACT_AUCTION.toLowerCase() ||
            data?.from?.toLowerCase() === CONTRACT_MARKET.toLowerCase()
              ? `${CHAIN_ID_MAPPING[detail?.chain?.id]?.linkAddress}/${data?.from}`
              : `/account/address/${data?.from}`
          }
        >
          <p>
            {fromUserProfile?.profile?.displayName
              ? fromUserProfile?.profile?.displayName?.length > 17
                ? formatCode(fromUserProfile?.profile?.displayName, 5, 5)
                : fromUserProfile?.profile?.displayName
              : formatCode(data?.from?.toLowerCase(), 5, 5)}
          </p>
        </Link>
      </td>
      <td className="from">
        <p>0 BNB</p>
      </td>
      <td>
        <p>{moment.unix(data?.blockTimestamp).format('YYYY-MM-DD HH:mm:ss')}</p>
      </td>
      <td className="from">
        <a
          href={`${CHAIN_ID_MAPPING[detail?.chain?.id]?.linkHash}/${data?.transactionHash}`}
          target="_blank"
          rel="noreferrer"
        >
          <p>{compactAddress(data?.transactionHash)}</p>
        </a>
      </td>
      <td className="price">
        <Box width="fit-content" className="sort-attr" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <img src="/images/account/icons/success.svg" alt="/images/account/icons/success.svg" />
          <img src="/images/account/icons/error.svg" alt="/images/account/icons/error.svg" />
        </Box>
      </td>
    </tr>
  )
}

const ModalMaketplace = () => {
  const dispatch = useDispatch()

  const { isModalOpenModalConfirm } = useSelector((state: any) => state.global)
  const [filter, setFilter] = useState<string[]>(['All'])

  const { account } = useWeb3React()
  const { t } = useTranslation()
  const [profileCreator, setProfileCreator] = useState<any>(null)
  const [nftOwner, setNftOwner] = useState<any>(null)
  const { toastError, toastSuccess, toastInfo }: any = useToast()
  const router = useRouter()

  const detail = isModalOpenModalConfirm.data
  const dataRender = isModalOpenModalConfirm?.dataRender

  const [approve, , onApproveAllNFT] = useApproveToken()
  const { fetchWithCatchTxError } = useCatchTxError()

  const { callWithGasPrice } = useCallWithGasPrice()
  const contractMethodAuction = useAuctionContract()
  const [removeAddToCart] = useRemoveAddToCart()
  const [feeBid] = useGetFeeBid(account)
  const [feeMarket] = useGetFeeBid(account)
  const contractTokenASDIT = useCreateTokenContract(CONTRACT_TOKEN_ASDIT)
  const [itemAuction, updateItemAuction] = useGetAuction(detail?.tokenContract, detail?.tokenId)
  const [itemSpot, updateItemSpot] = useGetSpot(
    detail?.tokenId ? detail?.tokenId : detail?.length > 0 && detail[0]?.nft?.tokenId,
    detail?.tokenContract ? detail?.tokenContract : detail?.length > 0 && detail[0]?.nft?.tokenContract,
  )

  const contractMethodMarket = useMarketContract()
  const contractNFT721 = useNFTBaseContract(true)
  const contractNFT1155 = useNFTBaseContract(false)
  const contractTokenNFT = useNFTBaseContract(true, detail?.tokenContract)

  const [viewModal, setViewModal] = useState(0)
  const [typeList, setTypeList] = useState<number>(0)
  const [reservePrice, setReservePrice] = useState<number>(0)
  const [duration, setDuration] = useState<number>(0)
  const [durationShowUI, setDurationShowUI] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)
  const [priceBidInput, setPriceBidInput] = useState<number>(0)
  const [priceBidDefault, setPriceBidDefault] = useState<number>(0)
  const [priceSpot, setPriceSpot] = useState<number>(0)
  const [quantity, setQuantity] = useState<number>(0)
  const [stepBid, setStepBid] = useState<number>(0)
  const [isSuggestedHistory, setIsSuggestedHistory] = useState(false)
  const [dataActivity, setDataActivity] = useState<any>([])
  const [activity] = useGetListActivivy(detail?.tokenId)

  const nftAmount = useGetAmountNft(
    account,
    contractNFT1155,
    detail?.tokenId?.toString(),
    detail?.chain?.tokenStandard?.name?.toLowerCase() === 'erc-1155',
  )

  useEffect(() => {
    if (activity?.auctionCreateds) {
      const dataSort = [
        // ...activity?.auctionCreateds?.map((obj) => ({
        //   ...obj,
        //   type: 'Auction',
        // })),
        // ...activity?.fillOrders?.map((obj) => ({
        //   ...obj,
        //   type: 'Sale',
        // })),
        // ...activity?.placeOrders?.map((obj) => ({
        //   ...obj,
        //   type: 'Listing',
        // })),
        ...activity?.transfers?.map((obj) => ({
          ...obj,
          type:
            obj.to === '0x000000000000000000000000000000000000dead'
              ? 'Burn'
              : obj.from === '0x0000000000000000000000000000000000000000'
              ? 'Mint'
              : obj?.to?.toLowerCase() === CONTRACT_AUCTION.toLowerCase() ||
                obj?.from?.toLowerCase() === CONTRACT_AUCTION.toLowerCase()
              ? 'Auction'
              : obj?.from?.toLowerCase() === CONTRACT_MARKET.toLowerCase()
              ? 'Sale'
              : 'Listing',

          price:
            obj.from === '0x0000000000000000000000000000000000000000'
              ? ''
              : activity?.placeOrders?.find((item) => item.blockNumber === obj.blockNumber)?.price
              ? activity?.placeOrders?.find((item) => item.blockNumber === obj.blockNumber)?.price / 10 ** 9
              : activity?.auctionCreateds?.find((item) => item.blockNumber === obj.blockNumber)?.startingPrice
              ? activity?.auctionCreateds?.find((item) => item.blockNumber === obj.blockNumber)?.startingPrice / 10 ** 9
              : 0,
        })),
      ]

      setDataActivity(dataSort?.sort((a, b) => b.blockTimestamp - a.blockTimestamp))
    }
  }, [activity])
  useEffect(() => {
    if (isModalOpenModalConfirm.type === 'CONFIRM_AUCTION') {
      setTypeList(1)
    } else {
      setTypeList(0)
    }
  }, [isModalOpenModalConfirm.type])

  useEffect(() => {
    setViewModal(isModalOpenModalConfirm.viewModalDefault)
  }, [isModalOpenModalConfirm.viewModalDefault])

  const handleBid = useCallback(
    async (_data, _amount, _CBSuccess, _CBError) => {
      const { detail: _item } = _data

      const params = {
        account,
        tokenId: _item?.tokenId,
        amount: _amount,
        feeBid,
        tokenContract: contractTokenASDIT,
        spender: CONTRACT_AUCTION,
        contractMethodAuction,
        nft: _item?.tokenContract,
      }

      approve(
        fetchWithCatchTxError,
        params.tokenContract,
        params.account,
        params.spender,
        params.amount,
        async () => {
          try {
            const receipt = await fetchWithCatchTxError(() => {
              return callWithGasPrice(
                params.contractMethodAuction,
                'bid',
                [params.tokenId, params.amount, params.account, params.nft],
                {
                  value: `${params.feeBid}`,
                },
              )
            })

            if (receipt?.status) {
              if (_CBSuccess) _CBSuccess()
              toastSuccess('Bid Successfully')
              updateItemAuction()
            } else {
              if (_CBError) _CBError()
              toastError('Bid failed')
            }
          } catch (error) {
            console.error('Could not bid', error)
            if (_CBError) _CBError()
          }
        },
        (messageError) => {
          toastError(messageError)
          if (_CBError) _CBError()
        },
        false,
      )
    },
    [
      account,
      approve,
      callWithGasPrice,
      contractMethodAuction,
      contractTokenASDIT,
      feeBid,
      fetchWithCatchTxError,
      toastError,
      toastSuccess,
      updateItemAuction,
    ],
  )

  const handleCancelAuction = useCallback(
    async (_data, _CBSuccess, _CBError) => {
      const { detail: _item } = _data

      const params = {
        account,
        tokenId: _item?.tokenId,
        feeBid,
        tokenContract: contractTokenASDIT,
        spender: CONTRACT_AUCTION,
        contractMethodAuction,
        nft: _item?.tokenContract,
      }

      if (params.tokenId && params.account && params.nft) {
        try {
          const receipt = await fetchWithCatchTxError(async () => {
            const dataReceipt = await params.contractMethodAuction.cancelAuction(params.tokenId, params.nft)
            return dataReceipt
          })

          if (receipt?.status) {
            if (_CBSuccess) _CBSuccess()
            toastSuccess('Cancel the auction successfully')
          } else {
            if (_CBError) _CBError()
            toastError('Cancel the auction failed')
          }
        } catch (error) {
          console.error('Could not cancel the auction', error)
          if (_CBError) _CBError()
        }
      }
    },
    [account, contractMethodAuction, contractTokenASDIT, feeBid, fetchWithCatchTxError, toastError, toastSuccess],
  )

  const onCreateAuction = useCallback(
    (_data, _amount, _CBSuccess, _CBError) => {
      const { detail: _item, duration: _duration } = _data

      const params = {
        account,
        tokenId: _item.tokenId,
        amount: getBigNumberString(_amount, 9),
        duration: _duration,
        spender: CONTRACT_AUCTION,
        contractNFT: contractTokenNFT,
        nft: _item?.tokenContract,
        nftToken: CONTRACT_TOKEN_ASDIT,
        is1155: _item?.chain?.tokenStandard?.name === 'ERC-1155',
        quantity: _item?.chain?.tokenStandard?.name === 'ERC-1155' ? +nftAmount : 1,
        stepBid,
      }

      onApproveAllNFT(
        fetchWithCatchTxError,
        params.contractNFT,
        params.account,
        params.spender,
        async () => {
          const success = await fetchWithCatchTxError(async () => {
            const create = await contractMethodAuction.createAuction(
              params.tokenId,
              params.amount,
              params.duration,
              params.account,
              params.nft,
              params.nftToken,
              params.quantity,
              ethers.utils.parseUnits(params.stepBid.toString(), 1),
            )

            return create
          })

          if (success?.status) {
            try {
              if (_CBSuccess) _CBSuccess(success)
            } catch (error) {
              if (_CBError) _CBError(error)
            }
          } else {
            const messageError = 'Occurred approve error!!!'
            if (_CBError) _CBError(messageError)
          }
        },
        (messageError) => {
          toastError(messageError)
          if (_CBError) _CBError(messageError)
        },
        false,
      )
    },
    [
      account,
      contractMethodAuction,
      contractTokenNFT,
      fetchWithCatchTxError,
      nftAmount,
      onApproveAllNFT,
      stepBid,
      toastError,
    ],
  )

  const onCreateSpot = useCallback(
    (_data, _amount, _CBSuccess, _CBError) => {
      const { detail: _item } = _data

      const params = {
        account,
        tokenId: _item.tokenId,
        amount: getBigNumberString(_amount, 9),
        spender: CONTRACT_MARKET,
        contractNFT: _item?.chain?.tokenStandard?.name === 'ERC-1155' ? contractNFT1155 : contractNFT721,
        token: CONTRACT_TOKEN_ASDIT,
        quantity: _item?.chain?.tokenStandard?.name === 'ERC-1155' ? quantity : 1,
        nft: _item?.tokenContract,
      }
      onApproveAllNFT(
        fetchWithCatchTxError,
        params.contractNFT,
        params.account,
        params.spender,
        async () => {
          let success: any = {}

          if (_item?.chain?.tokenStandard?.name === 'ERC-1155') {
            success = await fetchWithCatchTxError(async () => {
              const create = await contractMethodMarket.placeOrder1155(
                params.tokenId,
                params.amount,
                params.token,
                params.nft,
                params.quantity,
              )

              return create
            })
          } else {
            success = await fetchWithCatchTxError(async () => {
              const create = await contractMethodMarket.placeOrder(
                params.tokenId,
                params.amount,
                params.token,
                params.nft,
              )

              return create
            })
          }

          if (success?.status) {
            try {
              if (_CBSuccess) _CBSuccess(success)
            } catch (error) {
              if (_CBError) _CBError(error)
            }
          } else {
            const messageError = 'Occurred approve error!!!'
            if (_CBError) _CBError(messageError)
          }
        },
        (messageError) => {
          toastError(messageError)
          if (_CBError) _CBError(messageError)
        },
        false,
      )
    },
    [
      account,
      contractNFT1155,
      contractNFT721,
      quantity,
      onApproveAllNFT,
      fetchWithCatchTxError,
      contractMethodMarket,
      toastError,
    ],
  )

  useEffect(() => {
    setPriceBidInput(
      `${itemAuction?.endingPrice}` !== '0' && itemAuction?.startingPrice
        ? +formatBigNumber(itemAuction?.endingPrice, 9, 9) +
            +formatBigNumber(itemAuction?.endingPrice, 9, 9) * (+itemAuction?.stepBid / 100)
        : itemAuction?.startingPrice &&
            +formatBigNumber(itemAuction?.startingPrice, 9, 9) +
              +formatBigNumber(itemAuction?.startingPrice, 9, 9) * (+itemAuction?.stepBid / 100),
    )
    setPriceBidDefault(
      `${itemAuction?.endingPrice}` !== '0' && itemAuction?.endingPrice
        ? +formatBigNumber(itemAuction?.endingPrice, 9, 9)
        : itemAuction?.startingPrice && +formatBigNumber(itemAuction?.startingPrice, 9, 9),
    )
  }, [itemAuction?.endingPrice, itemAuction?.startingPrice, itemAuction?.stepBid])

  useEffect(() => {
    setGetProfileUserAddress(detail?.owner, (res) => setNftOwner(res))
    setGetProfileUserAddress(detail?.creator?.walletAddress, (res) => setProfileCreator(res))
  }, [detail])

  const handleBuy = useCallback(
    async (_data, _amount, _CBSuccess, _CBError) => {
      const { detail: _item } = _data
      const params = {
        account,
        tokenId: _item?.length < 2 ? _item[0]?.nft?.tokenId : _item?.tokenId,
        amount: _amount,
        feeMarket,
        tokenContract: contractTokenASDIT,
        spender: CONTRACT_MARKET,
        contractMethodMarket,
        token: itemSpot?.token,
        is1155: _item?.chain?.tokenStandard?.name === 'ERC-1155',
        nft: _item?.tokenContract ? _item?.tokenContract : itemSpot?.nftToken,
      }

      const decimals = await contractTokenASDIT.decimals()
      const arrTokenId = []
      const arrNft = []
      let totalAmount = 0

      if (_item?.length < 2 || !_item?.length) {
        approve(
          fetchWithCatchTxError,
          params.tokenContract,
          params.account,
          params.spender,
          params.amount,
          async () => {
            try {
              let receipt: any = {}

              receipt = await fetchWithCatchTxError(() => {
                return callWithGasPrice(
                  params.contractMethodMarket,
                  'fillOrder1155',
                  [params.tokenId, params.token, params.nft],
                  {
                    value: `${params.feeMarket}`,
                  },
                )
              })
              receipt = await fetchWithCatchTxError(() => {
                return callWithGasPrice(
                  params.contractMethodMarket,
                  'fillOrder',
                  [params.tokenId, params.token, params.nft],
                  {
                    value: `${params.feeMarket}`,
                  },
                )
              })

              if (receipt?.status) {
                if (_CBSuccess) _CBSuccess()
                toastSuccess('Buy Successfully')
                if (_item?.length === 1) {
                  removeAddToCart(_item[0])
                } else {
                  removeAddToCart(_item)
                  updateItemSpot()
                }
              } else {
                if (_CBError) _CBError()
                toastError('Buy failed')
              }
            } catch (error) {
              console.error('Could not buy', error)
              if (_CBError) _CBError()
            }
          },
          (messageError) => {
            toastError(messageError)
            if (_CBError) _CBError()
          },
          false,
        )
      } else {
        _item?.forEach((item) => {
          arrTokenId.push(item?.nft?.tokenId)
          arrNft.push(item?.nft?.tokenContract)
          totalAmount += +item?.salePrice * 10 ** decimals
        })

        approve(
          fetchWithCatchTxError,
          params.tokenContract,
          params.account,
          params.spender,
          totalAmount,
          async () => {
            try {
              let receipt: any = {}

              receipt = await fetchWithCatchTxError(() => {
                return callWithGasPrice(
                  params.contractMethodMarket,
                  'fillOrderMulti',
                  [arrTokenId, params.token, arrNft],
                  {
                    value: `${params.feeMarket}`,
                  },
                )
              })

              if (receipt?.status) {
                if (_CBSuccess) _CBSuccess()
                toastSuccess('Buy Successfully')
                if (_item?.length === 1) {
                  removeAddToCart(_item[0])
                } else {
                  removeAddToCart(_item)
                  updateItemSpot()
                }
              } else {
                if (_CBError) _CBError()
                toastError('Buy failed')
              }
            } catch (error) {
              console.error('Could not buy', error)
              if (_CBError) _CBError()
            }
          },
          (messageError) => {
            toastError(messageError)
            if (_CBError) _CBError()
          },
          false,
        )
      }
    },
    [
      account,
      approve,
      callWithGasPrice,
      contractMethodMarket,
      contractTokenASDIT,
      feeMarket,
      fetchWithCatchTxError,
      itemSpot,
      toastError,
      toastSuccess,
      removeAddToCart,
      updateItemSpot,
    ],
  )

  const handleCancelBuy = useCallback(
    async (_data, _CBSuccess, _CBError) => {
      const { detail: _item } = _data

      const params = {
        account,
        tokenId: _item?.tokenId,
        feeMarket,
        tokenContract: contractTokenASDIT,
        spender: CONTRACT_MARKET,
        contractMethodMarket,
        token: itemSpot?.token,
        nft: _item?.chain?.tokenStandard?.address,
        is1155: _item?.chain?.tokenStandard?.name === 'ERC-1155',
      }

      if (params.tokenId && params.token) {
        try {
          const receipt = await fetchWithCatchTxError(async () => {
            const dataReceipt = await params.contractMethodMarket.cancelOrder(
              params.tokenId,
              params.token,
              params.nft,
              params.is1155,
            )
            return dataReceipt
          })

          if (receipt?.status) {
            if (_CBSuccess) _CBSuccess()
            toastSuccess('Unlisted Successfully')
          } else {
            if (_CBError) _CBError()
            toastError('Unlisted failed')
          }
        } catch (error) {
          console.error('Could not unlisted', error)
          if (_CBError) _CBError()
        }
      }
    },
    [
      account,
      contractMethodMarket,
      contractTokenASDIT,
      feeMarket,
      fetchWithCatchTxError,
      itemSpot?.token,
      toastError,
      toastSuccess,
    ],
  )

  const handleConfirm = useCallback(() => {
    if (isModalOpenModalConfirm.type === 'CONFIRM_AUCTION') {
      setLoading(true)
      const amount = getBigNumberString(priceBidInput, 9)

      if (itemAuction?.seller !== account && !isModalOpenModalConfirm.delisting) {
        return handleBid(
          { detail },
          amount,
          () => {
            dispatch(
              setIsModalOpenModalConfirm({
                toggle: false,
                type: '',
                viewModalDefault: 0,
                data: {},
              }),
            )
            setViewModal(0)

            setLoading(false)
          },
          () => {
            setLoading(false)
          },
        )
      }

      return handleCancelAuction(
        { detail },
        () => {
          dispatch(
            setIsModalOpenModalConfirm({
              toggle: false,
              type: '',
              viewModalDefault: 0,
              data: {},
            }),
          )
          setViewModal(0)
          setLoading(false)
          router.push(
            {
              pathname: `/nft/detail/${detail?.id}`,
            },
            undefined,
            { scroll: true },
          )
        },
        () => {
          setLoading(false)
        },
      )
    }
    if (isModalOpenModalConfirm.type === 'CONFIRM_SPOT' || isModalOpenModalConfirm.type === 'CONFIRM_MULTI_SPOT') {
      setLoading(true)
      const amount = itemSpot?.price
      setViewModal(2)

      if (itemSpot?.owner !== account && !isModalOpenModalConfirm.delisting) {
        return handleBuy(
          { detail },
          amount,
          () => {
            dispatch(
              setIsModalOpenModalConfirm({
                toggle: false,
                type: '',
                viewModalDefault: 0,
                data: {},
              }),
            )
            setViewModal(0)
            setLoading(false)
            router.push(
              {
                pathname: `/nft/detail/${detail?.id}`,
              },
              undefined,
              { scroll: false },
            )
          },
          () => {
            setLoading(false)
          },
        )
      }

      return handleCancelBuy(
        { detail },
        () => {
          dispatch(
            setIsModalOpenModalConfirm({
              toggle: false,
              type: '',
              viewModalDefault: 0,
              data: {},
            }),
          )
          setViewModal(0)
          setLoading(false)
          router.push(
            {
              pathname: `/nft/detail/${detail?.id}`,
            },
            undefined,
            { scroll: false },
          )
        },
        () => {
          setLoading(false)
        },
      )
    }
    if (isModalOpenModalConfirm.type === 'MAKE_OFFER') {
      setLoading(true)
      const amount = itemSpot?.price
      setViewModal(0)
      if (itemSpot?.owner !== account && !isModalOpenModalConfirm.delisting) {
        return handleBuy(
          { detail },
          amount,
          () => {
            dispatch(
              setIsModalOpenModalConfirm({
                toggle: false,
                type: '',
                viewModalDefault: 0,
                data: {},
              }),
            )
            setLoading(false)
            router.push(
              {
                pathname: `/nft/detail/${detail?.id}`,
              },
              undefined,
              { scroll: false },
            )
          },
          () => {
            setLoading(false)
          },
        )
      }

      return handleCancelBuy(
        { detail },
        () => {
          dispatch(
            setIsModalOpenModalConfirm({
              toggle: false,
              type: '',
              viewModalDefault: 0,
              data: {},
            }),
          )
          setLoading(false)
          router.push(
            {
              pathname: `/nft/detail/${detail?.id}`,
            },
            undefined,
            { scroll: false },
          )
        },
        () => {
          setLoading(false)
        },
      )
    }

    if (typeList === 1) {
      if (reservePrice <= 0) {
        return toastError('Reserve price must be greater than 0')
      }

      if (duration < 12 * 3600 || duration > 7 * 24 * 3600) {
        return toastError('Expiration is not valid')
      }

      return setViewModal(1)
    }

    if (typeList === 0) {
      if (priceSpot <= 0) {
        return toastError('Amount must be greater than 0')
      }

      return setViewModal(1)
    }

    return null
  }, [
    account,
    detail,
    dispatch,
    duration,
    handleBid,
    handleBuy,
    handleCancelAuction,
    handleCancelBuy,
    isModalOpenModalConfirm.type,
    isModalOpenModalConfirm.delisting,
    itemAuction?.seller,
    itemSpot?.owner,
    itemSpot?.price,
    priceBidInput,
    priceSpot,
    reservePrice,
    router,
    toastError,
    typeList,
  ])

  const handleAction = useCallback(() => {
    if (typeList === 1) {
      setLoading(true)

      setViewModal(2)
      onCreateAuction(
        { detail, duration },
        reservePrice,
        () => {
          setLoading(false)
          toastSuccess('Create a successful auction!')
          setViewModal(3)
        },
        (messageError) => {
          setViewModal(0)
          toastError(messageError)
          setLoading(false)
        },
      )
    }

    if (typeList === 0) {
      setLoading(true)

      setViewModal(2)
      onCreateSpot(
        { detail },
        priceSpot,
        () => {
          setLoading(false)
          toastSuccess('Create a successful spot!')
          setViewModal(3)
        },
        (messageError) => {
          setViewModal(0)
          toastError(messageError)
          setLoading(false)
        },
      )
    }

    return null
  }, [
    detail,
    duration,
    onCreateAuction,
    onCreateSpot,
    priceSpot,
    reservePrice,
    setViewModal,
    toastError,
    toastSuccess,
    typeList,
  ])

  const handleClaimAction = useCallback(
    async (_data, _CBSuccess, _CBError) => {
      const { detail: _item } = _data

      const params = {
        account,
        tokenId: _item?.tokenId,
        feeBid,
        tokenContract: contractTokenASDIT,
        spender: CONTRACT_AUCTION,
        contractMethodAuction,
      }

      if (params.tokenId && params.account) {
        try {
          const receipt = await fetchWithCatchTxError(async () => {
            const dataReceipt = await params.contractMethodAuction.claim(params.tokenId)
            return dataReceipt
          })

          if (receipt?.status) {
            if (_CBSuccess) _CBSuccess()
            toastSuccess('Claim successfully')
          } else {
            if (_CBError) _CBError()
            toastError('Claim failed')
          }
        } catch (error) {
          console.error('Could not claim', error)
          if (_CBError) _CBError()
        }
      }
    },
    [account, contractMethodAuction, contractTokenASDIT, feeBid, fetchWithCatchTxError, toastError, toastSuccess],
  )

  const submitHandleClaimAction = () => {
    handleClaimAction(
      { detail },
      () => {
        dispatch(
          setIsModalOpenModalConfirm({
            toggle: false,
            type: '',
            viewModalDefault: 0,
            data: {},
          }),
        )
        setViewModal(0)
        setLoading(false)
      },
      () => {
        setLoading(false)
      },
    )
  }

  const handleCancel = useCallback(() => {
    if (loading) {
      return null
    }

    if (viewModal === 0) {
      dispatch(
        setIsModalOpenModalConfirm({
          toggle: false,
          type: '',
          viewModalDefault: 0,
          data: {},
        }),
      )
      setViewModal(0)
    }

    if (viewModal === 3) {
      dispatch(
        setIsModalOpenModalConfirm({
          toggle: false,
          type: '',
          viewModalDefault: 0,
          data: {},
        }),
      )
      setViewModal(0)

      if (typeList === 0) {
        router.push(
          {
            pathname: `/marketplace/spot/${detail?.id}`,
          },
          undefined,
          { scroll: true },
        )
      }
      if (typeList === 1) {
        router.push(
          {
            pathname: `/marketplace/auction/${detail?.id}`,
          },
          undefined,
          { scroll: true },
        )
      }
    }

    if (viewModal === 1) {
      setViewModal(0)
    }

    return null
  }, [detail?.id, dispatch, loading, router, typeList, viewModal])
  const handleSetDateEnd = useCallback((day) => {
    setDurationShowUI(day)
    setDuration(Math.floor((day.valueOf() - moment().valueOf()) / 1000))
  }, [])

  useEffect(() => {
    if (isModalOpenModalConfirm.toggle) {
      dispatch(setFilterBlur(true))
    } else {
      dispatch(setFilterBlur(false))
    }
  }, [dispatch, isModalOpenModalConfirm.toggle])

  const handlePriceSpot = (e) => {
    if (e >= 0.1 && e < 100000000) setPriceSpot(e)
    else if (e >= 100000000) setPriceSpot(99999999.999)
    else setPriceSpot(0.1)
  }

  const handleReservePrice = (e) => {
    if (e >= 0.1 && e < 100000000) setReservePrice(e)
    else if (e >= 100000000) setReservePrice(99999999.999)
    else setReservePrice(0.1)
  }

  return (
    <Modal
      open={isModalOpenModalConfirm.toggle}
      onCancel={handleCancel}
      footer={false}
      width={viewModal === 0 ? 1250 : 425}
      closeIcon={
        <WrapperIcon>
          <CloseIcon />
        </WrapperIcon>
      }
    >
      <WrapperContent>
        {viewModal === 0 ? (
          <>
            <div className="modal-title">
              <p>
                {isModalOpenModalConfirm?.delisting
                  ? 'Delisting'
                  : isModalOpenModalConfirm?.type === 'MAKE_OFFER'
                  ? 'Listing Suggested'
                  : 'List'}
              </p>
            </div>

            <div className="modal-body">
              <Row gutter={[30, 30]}>
                <Col span={24} lg={12}>
                  <div className="wrap-nft">
                    <Row gutter={[20, 20]}>
                      <Col span={24} lg={9}>
                        <div className="wrap-avatar">
                          {detail?.moreInfo?.itemType === 'video/mp4' ? (
                            <video width="100%" height="100%" autoPlay muted loop playsInline>
                              <source src={detail?.animationUrl} type="video/mp4" />
                            </video>
                          ) : (
                            <img src={detail?.image || detail?.animationUrl} alt={detail?.name} />
                          )}
                        </div>
                      </Col>

                      <Col span={24} lg={15}>
                        <div className="wrap-info">
                          <p className="item-info-name">
                            {detail?.name?.length < 26 ? detail?.name : `${detail?.name?.slice(0, 16)}...`}
                          </p>

                          <div className="item-info">
                            <p>Collection</p>

                            <Link href={`/collection/detail/${detail?.collection?.id}`}>
                              <p>{detail?.collection?.name || '-'}</p>
                            </Link>
                          </div>

                          <div className="item-info">
                            <p>Created by</p>
                            <Link href={`/account/address/${detail?.creator?.walletAddress}`}>
                              <p>
                                {profileCreator?.profile?.displayName
                                  ? profileCreator?.profile?.displayName?.length > 30
                                    ? compactAddress(profileCreator?.profile?.displayName)
                                    : profileCreator?.profile?.displayName
                                  : compactAddress(detail?.creator?.walletAddress?.toLowerCase())}
                              </p>
                            </Link>
                          </div>

                          <div className="item-info">
                            <p>Current owner</p>
                            <Link href={`/account/address/${detail?.owner}`}>
                              <p>
                                {nftOwner?.profile?.displayName
                                  ? nftOwner?.profile?.displayName?.length > 30
                                    ? compactAddress(nftOwner?.profile?.displayName)
                                    : nftOwner?.profile?.displayName
                                  : compactAddress(detail?.owner?.toLowerCase())}
                              </p>
                            </Link>
                          </div>

                          <div className="item-info">
                            <p>Blockchain</p>
                            <p>{detail?.chain?.name}</p>
                          </div>

                          <div className="item-info">
                            <p>Token standard</p>
                            <p>{detail?.chain?.tokenStandard?.name}</p>
                          </div>

                          <div className="item-info">
                            <p>Smartcontract</p>
                            <a
                              href={`${CHAIN_ID_MAPPING[detail?.chain?.id]?.linkAddress}${detail?.mintContract}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <p>{compactAddress(detail?.mintContract)}</p>
                            </a>
                          </div>

                          <div className="item-info">
                            <p>Token ID</p>
                            <a
                              href={`${CHAIN_ID_MAPPING[detail?.chain?.id]?.linkTokenId}${
                                detail?.chain?.tokenStandard?.address
                              }?a=${detail?.tokenId}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <p>
                                {detail?.tokenId?.length > 15 ? formatCode(detail?.tokenId, 5, 5) : detail?.tokenId}
                              </p>
                            </a>
                          </div>

                          <div className="item-info">
                            <p>Creator fee</p>
                            <p>{detail?.creatorFee / 100}%</p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col span={24} lg={12}>
                  <div className="wrap-listing-method">
                    {isModalOpenModalConfirm.type !== 'MAKE_OFFER' && (
                      <p className="item-info-name">
                        {isModalOpenModalConfirm?.delisting ? 'Delisting method' : 'Listing method'}{' '}
                      </p>
                    )}

                    {isModalOpenModalConfirm.type !== 'MAKE_OFFER' ? (
                      <div className="wrap-item-listing-method">
                        {isModalOpenModalConfirm.type !== 'CONFIRM_AUCTION' && (
                          <div className="item-listing-method">
                            <button
                              type="button"
                              className={typeList === 0 ? 'active' : ''}
                              onClick={() => setTypeList(0)}
                            >
                              <SpotIcon />
                              Spot
                            </button>
                          </div>
                        )}

                        {isModalOpenModalConfirm.type !== 'CONFIRM_SPOT' && (
                          <div className="item-listing-method">
                            <button
                              type="button"
                              className={typeList === 1 ? 'active' : ''}
                              onClick={() => {
                                if (detail?.chain?.tokenStandard?.name !== 'ERC-1155') {
                                  setTypeList(1)
                                } else {
                                  toastInfo('NFT 1155 cannot be auctioned')
                                }
                              }}
                            >
                              <Aution />
                              Auction
                            </button>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="wrap-item-listing-method">
                        <div className="item-listing-method">
                          <button
                            type="button"
                            className={!isSuggestedHistory ? 'active' : ''}
                            onClick={() => setIsSuggestedHistory(false)}
                          >
                            Suggesting
                          </button>
                        </div>
                        <div className="item-listing-method">
                          <button
                            type="button"
                            className={isSuggestedHistory ? 'active' : ''}
                            onClick={() => setIsSuggestedHistory(true)}
                          >
                            Suggested History
                          </button>
                        </div>
                      </div>
                    )}

                    {typeList === 0 ? (
                      <>
                        {isModalOpenModalConfirm.type === 'CONFIRM_SPOT' ? (
                          <>
                            <div className="wrap-item-listing-method">
                              <div className="item-listing-method">
                                <p className="item-listing-method-title">Price</p>
                                <InputNumber
                                  addonAfter={selectAfterPrice}
                                  disabled
                                  value={
                                    itemSpot?.price > 0
                                      ? formatBigNumber(itemSpot?.price, 9, 9)
                                      : dataRender?.originalPrice
                                  }
                                />
                              </div>

                              <div className="item-listing-method" />
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="wrap-item-listing-method">
                              <div className="item-listing-method">
                                <p className="item-listing-method-title">Price</p>
                                <InputNumber
                                  addonAfter={selectAfterPrice}
                                  defaultValue={priceSpot}
                                  value={priceSpot}
                                  onChange={handlePriceSpot}
                                  min={0}
                                />
                              </div>

                              {detail?.chain?.tokenStandard?.name === 'ERC-1155' ? (
                                <div className="item-listing-method">
                                  <p className="item-listing-method-title">Quantity</p>
                                  <InputNumber
                                    defaultValue={quantity}
                                    value={quantity}
                                    onChange={(e) => {
                                      if (e <= detail.quantity) setQuantity(+e)
                                      else setQuantity(detail.quantity)
                                    }}
                                    min={0}
                                    max={+detail.quantity}
                                  />
                                </div>
                              ) : (
                                <div className="item-listing-method" />
                              )}
                            </div>
                            {isModalOpenModalConfirm.type !== 'MAKE_OFFER' && (
                              <div className="wrap-item-listing-method">
                                <div>
                                  <p className="item-listing-method-title">Platform fee: 1.5%</p>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {isModalOpenModalConfirm.type === 'CONFIRM_AUCTION' ? (
                          <>
                            <div className="wrap-item-listing-method">
                              <div className="item-listing-method">
                                <p className="item-listing-method-title">Current Price</p>
                                <InputNumber addonAfter={selectAfterPrice} value={priceBidDefault} disabled />
                              </div>

                              <div className="item-listing-method">
                                <p className="item-listing-method-title">Bid Price</p>
                                <InputNumber
                                  addonAfter={selectAfterPrice}
                                  value={priceBidInput}
                                  min={
                                    `${itemAuction?.endingPrice}` !== '0' && itemAuction?.startingPrice
                                      ? +formatBigNumber(itemAuction?.endingPrice, 9, 9) +
                                        +formatBigNumber(itemAuction?.endingPrice, 9, 9) * (+itemAuction?.stepBid / 100)
                                      : itemAuction?.startingPrice &&
                                        +formatBigNumber(itemAuction?.startingPrice, 9, 9) +
                                          +formatBigNumber(itemAuction?.startingPrice, 9, 9) *
                                            (+itemAuction?.stepBid / 100)
                                  }
                                  onChange={(e) => {
                                    setPriceBidInput(+e)
                                  }}
                                  disabled={itemAuction?.seller === account}
                                />
                              </div>
                            </div>

                            <div className="wrap-item-listing-method">
                              <div className="item-listing-method">
                                <p className="item-listing-method-title">Start</p>
                                <DatePicker
                                  format="YYYY-MM-DD HH:mm:ss"
                                  disabled
                                  value={moment(+itemAuction?.startAt * 1000)}
                                />
                              </div>

                              <div className="item-listing-method">
                                <p className="item-listing-method-title">Expiration</p>
                                <DatePicker
                                  format="YYYY-MM-DD HH:mm:ss"
                                  disabledDate={disabledDate}
                                  showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                                  onChange={(day) => handleSetDateEnd(day)}
                                  disabled
                                  value={moment((+itemAuction?.startAt + +itemAuction?.duration) * 1000)}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="wrap-item-listing-method">
                              <div className="item-listing-method">
                                <p className="item-listing-method-title">Reserve price</p>
                                <InputNumber
                                  addonAfter={selectAfterPrice}
                                  defaultValue={reservePrice}
                                  value={reservePrice}
                                  onChange={handleReservePrice}
                                  min={0}
                                />
                              </div>

                              <div className="item-listing-method">
                                <p className="item-listing-method-title">Minimum bid increment (%)</p>
                                <InputNumber
                                  addonAfter={selectAfterPrice}
                                  value={stepBid}
                                  onChange={(e) => {
                                    setStepBid(e)
                                  }}
                                  min={0.1}
                                />
                              </div>
                            </div>

                            <div className="wrap-item-listing-method">
                              <div className="item-listing-method">
                                <p className="item-listing-method-title">Start</p>
                                <DatePickerNow format="YYYY-MM-DD HH:mm:ss" disabled />
                              </div>

                              <div className="item-listing-method">
                                <p className="item-listing-method-title">Expiration</p>
                                <DatePicker
                                  format="YYYY-MM-DD HH:mm:ss"
                                  disabledDate={disabledDate}
                                  showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                                  onChange={(day) => handleSetDateEnd(day)}
                                  value={durationShowUI && moment(durationShowUI)}
                                />
                              </div>
                            </div>
                            {isModalOpenModalConfirm.type !== 'MAKE_OFFER' && (
                              <div className="wrap-item-listing-method">
                                <div>
                                  <p className="item-listing-method-title">Platform fee: 1.5%</p>
                                </div>
                                <div>
                                  <p style={{ color: '#006DFE' }}>Not less than 12 hours, not more than 7 days</p>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                  {isModalOpenModalConfirm.type === 'MAKE_OFFER' && (
                    <div className="wrap-item-listing-method" style={{ borderRadius: '12px' }}>
                      <div className="box-info">
                        <div className="box-info-table">
                          <table>
                            <thead>
                              <tr>
                                <th>User</th>
                                <th>Amount</th>
                                <th>End time</th>
                                <th>Tx</th>
                                <th>Action</th>
                              </tr>
                            </thead>

                            <tbody>
                              {dataActivity.length ? (
                                dataActivity?.map((item, index) => (
                                  <ActivityItem key={item.id} data={item} detail={detail} />
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={5}>
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>

              <div className="button-confirm">
                <BaseButton
                  className="active"
                  loading={loading}
                  onClick={() => {
                    if (isModalOpenModalConfirm.type === 'CLAIM_AUCTION') {
                      submitHandleClaimAction()
                    } else {
                      handleConfirm()
                    }
                  }}
                >
                  Continue
                </BaseButton>
              </div>
            </div>
          </>
        ) : viewModal === 1 ? (
          <>
            {isModalOpenModalConfirm.type === 'CLAIM_AUCTION' ? (
              <ModalLoading>
                <div className="title-modal" style={{ marginBottom: '10px' }}>
                  <img width="50px" height="auto" src="/logo.png" alt="" />
                </div>
                <div className="body-modal">
                  <p className="body-modal-title">{t('Remind')}</p>
                  <p>{t(`Are you sure you want to claim?`)}</p>

                  <div className="action-modal">
                    <button
                      onClick={() => {
                        dispatch(
                          setIsModalOpenModalConfirm({
                            toggle: false,
                            type: '',
                            viewModalDefault: 0,
                            data: {},
                          }),
                        )
                        setViewModal(0)
                      }}
                      className="btn-cancel"
                      type="button"
                    >
                      {t('Huỷ bỏ')}
                    </button>
                    <button onClick={submitHandleClaimAction} className="btn-confirm" type="button">
                      {t('Xác nhận')}
                    </button>
                  </div>
                </div>
              </ModalLoading>
            ) : (
              <ModalLoading>
                <div className="title-modal" style={{ marginBottom: '10px' }}>
                  <img width="50px" height="auto" src="/logo.png" alt="" />
                </div>
                <div className="body-modal">
                  <p className="body-modal-title">{t('Remind')}</p>
                  <p>
                    {isModalOpenModalConfirm?.delisting
                      ? `${t('Bạn muốn hủy niêm yết NFT ')} ${isModalOpenModalConfirm?.data?.name}`
                      : t(`Make sure the information is accurate!`)}
                  </p>

                  <div className="action-modal">
                    <button onClick={() => setViewModal(0)} className="btn-cancel" type="button">
                      {t('Huỷ bỏ')}
                    </button>
                    <button
                      onClick={() => {
                        if (
                          isModalOpenModalConfirm?.delisting ||
                          isModalOpenModalConfirm?.type === 'CONFIRM_MULTI_SPOT'
                        ) {
                          handleConfirm()
                        } else {
                          handleAction()
                        }
                      }}
                      className="btn-confirm"
                      type="button"
                    >
                      {t('Xác nhận')}
                    </button>
                  </div>
                </div>
              </ModalLoading>
            )}
          </>
        ) : viewModal === 2 ? (
          <ModalLoading>
            <div className="title-modal">
              <img style={{ margin: '40px 0' }} width={50} src="/images/loading.gif" alt="" />
            </div>
            <div className="body-modal">
              <p>{t(`Please wait a few seconds...`)}</p>
            </div>
          </ModalLoading>
        ) : (
          <ModalLoading>
            <div className="title-modal">
              <img width="50px" height="auto" src="/images/brand/check-blue.png" alt="" />
            </div>
            <div className="body-modal">
              {typeList === 1 ? (
                <p>
                  You have successfully participated in the auction NFT{' '}
                  <Link href={`/marketplace/auction/${detail?.id}`}>{detail?.name}</Link>.
                </p>
              ) : (
                <p>
                  NFT <Link href={`/marketplace/spot/${detail?.id}`}>{detail?.name}</Link> has been listed successfully!
                </p>
              )}
            </div>
          </ModalLoading>
        )}
      </WrapperContent>
    </Modal>
  )
}

export default ModalMaketplace
